import * as fbApi from '@/api/fb';
import globalStore from '@/stores/store';

import emitter from './event-bus';

export function base64ToFile(base64String, fileName) {
  try {
    const arr = base64String.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  } catch (error) {
    console.error(error);
  }
}

/** 选择图片， base64 */
export const chooseImg = () => {
  return new Promise(resolve => {
    window.android?.chooseHeadImg();
    const cb = img => {
      resolve(`data:image:png;base64,${img}`);
    };
    window.transmitAvatar = cb;
  });
};

/**
 * 下载图片到手机
 * img - base64
 *
 */
export const downloadImage = (img: string) => {
  window.android?.saveBase64Image(img);
};

/** 在浏览器打开 */
export const openInBrowser = (url: string) => {
  return window.android?.openLinkInBrowser(url);
};

/**
 * 给客户端传递用户 id
 */
export const saveUserID = userId => {
  return window.android?.saveUserID(`${userId}`);
};

/** 是否是在 apk 内 */
export const isInApk = () => {
  if (!window.android) return false;

  if (!window.android?.getDeviceID || !window.android?.saveUserID) return false;

  return true;
};
export const isInIPA = () => {
  if (!window.android) return false;

  if (!window.android?.getDeviceID || !window.android?.saveUserID) return false;

  return !!window.android?.isIpa;
};
// /** 更新fb 信息 */
// export const updateFbInfo = () => {
//   globalStore.eventEmitter.emit({ type: 'fb_bind_info_update' });
// };
/** 更新fb 信息 */
export const updateFbInfo = () => {
  emitter.emit('fb_bind_info_update');
};

/** 是否展示更新fb 信息 */
export const getIsShowFbBind = () => {
  return !!window.android?.isShowFbBind && window.android?.isShowFbBind();
};

/** fb 绑定 */
export const goFbLogin = data => {
  return window.android?.openFBLogin(data);
};

/** fb 账号绑定领奖 */
export const fbReward = async (info, header) => {
  // 需要转换一下
  await fbApi.fbReward({
    ...JSON.parse(info),
    header
  });

  window.updateFbInfo?.();
  globalStore.fetchBalance();
};

/** 注入方法 */
export const invoke = () => {
  if (isInApk()) {
    window.fbReward = fbReward;
    window.updateFbInfo = updateFbInfo;
  }
};
